import { Link } from "react-router-dom";
import {
  Layers,
  Waves,
  TreePine,
  SquareStack,
  Grid3x3,
  Sparkles,
  ArrowRight,
} from "lucide-react";

/**
 * Homepage flooring-category discovery grid.
 *
 * Each card links to /search with the matching flooring_type query so the
 * marketplace opens pre-filtered. We use icon-led cards rather than dropping
 * generic stock photos into every tile — the icons stay on-brand (cream +
 * dark-green + orange) and never risk showing rugs or unrelated interiors.
 */
const CATEGORIES = [
  {
    slug: "carpet",
    title: "Carpet remnants",
    body: "Roll ends and offcuts matched to your room.",
    icon: <Layers className="w-6 h-6" />,
    tint: "bg-[#2A5A3B]/10 text-[#2A5A3B]",
  },
  {
    slug: "vinyl",
    title: "Vinyl flooring",
    body: "Roll ends and surplus vinyl for rooms of all sizes.",
    icon: <Waves className="w-6 h-6" />,
    tint: "bg-[#E05915]/10 text-[#E05915]",
  },
  {
    slug: "laminate",
    title: "Laminate flooring",
    body: "Surplus packs, clearance stock and discontinued ranges.",
    icon: <SquareStack className="w-6 h-6" />,
    tint: "bg-amber-500/10 text-amber-700",
  },
  {
    slug: "lvt",
    title: "LVT",
    body: "End-of-line, surplus and clearance luxury vinyl tiles.",
    icon: <Sparkles className="w-6 h-6" />,
    tint: "bg-sky-500/10 text-sky-700",
  },
  {
    slug: "carpet_tiles",
    title: "Carpet tiles",
    body: "Surplus boxes and commercial flooring stock.",
    icon: <Grid3x3 className="w-6 h-6" />,
    tint: "bg-rose-500/10 text-rose-700",
  },
];

export default function CategoryGrid() {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="category-grid">
      {CATEGORIES.map((c) => (
        <Link
          key={c.slug}
          to={`/search?flooring_type=${c.slug}`}
          className="group relative bg-white border border-slate-200 rounded-2xl p-5 hover:border-[#E05915]/40 hover:-translate-y-0.5 hover:shadow-md transition-all flex flex-col"
          data-testid={`category-${c.slug}`}
        >
          <div className={`grid place-items-center w-12 h-12 rounded-xl ${c.tint} mb-4`}>
            {c.icon}
          </div>
          <h3 className="font-display font-semibold text-lg text-slate-900">{c.title}</h3>
          <p className="text-sm text-slate-600 mt-1 flex-1">{c.body}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#E05915] group-hover:gap-2 transition-[gap]">
            Browse {c.title.toLowerCase()} <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </Link>
      ))}
    </div>
  );
}
